<template>
  <section>
    <notifications></notifications>

    <base-header>
      <div class="row align-items-center">
        <div
          class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 align-items-center"
        >
          <div class="d-flex align-items-center">
            <div>
              <el-tooltip content="Back" placement="bottom">
                <base-button
                  type="neutral"
                  class="btn-icon-only"
                  @click="goToPreviousPage()"
                >
                  <i class="flaticon-left-1"></i>
                </base-button>
              </el-tooltip>
            </div>

            <div>
              <h1 class="title-view">
                Reservation
              </h1>

              <div class="box-id">
                <h2 class="number-id">
                  {{ bookingNumber }}
                </h2>
                <span class="ml-2 mr-2">|</span>
                <div class="status-tab" v-if="reservation.status">
                  <div
                    class="badge-status text-status "
                    v-bind:class="getStatusClass(reservation.status)"
                  >
                    {{ getReservationStatusFormat(reservation.status) }}
                  </div>

                  <span class="ml-2 mr-2">|</span>
                  <div class="status-payment">
                    <PaymentStatus
                      :payment="payment"
                      :paymentLinkStatus="paymentLinkStatus"
                      :paymentLink="paymentLink"
                      :paymentType="reservation.payment_type"
                      :status="reservation.status"
                      classes="badge-status px-0"
                    />
                  </div>

                  <FirstBookingBadge :isFirstBooking="isFirstBooking" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 align-items-center alinmov2"
        >
          <div class="box-buttons">
            <div class="d-inline-block mr-1">
              <b-form-group v-slot="{ ariaDescribedbyview }">
                <b-form-radio-group
                  id="btn-radios-view"
                  v-model="mode"
                  :aria-describedby="ariaDescribedbyview"
                  name="radios-btn-default"
                  buttons
                  button-variant="outline-neutral pc-4"
                >
                  <b-form-radio value="view">
                    <el-tooltip content="Expanded View" placement="bottom"
                      ><i class="flaticon-bold-menu mt-1"></i></el-tooltip
                  ></b-form-radio>
                  <b-form-radio value="list">
                    <el-tooltip content="List View" placement="bottom"
                      ><i class="flaticon-two mt-1"></i></el-tooltip
                  ></b-form-radio>
                </b-form-radio-group>
              </b-form-group>
            </div>

            <base-dropdown
              v-if="
                canUserChangeStatus ||
                  canUserMarkBookingAsPaid ||
                  canUserSendPaymentLink
              "
              menu-on-left
              class="nav-item"
              tag="li"
              title-tag="a"
              title-classes="btn min-button btn-outline-neutral ml-2"
              title="Actions"
            >
              <base-button slot="title" type="none" class="p-0 min-button">
                <i class="flaticon-bold-menu-1"></i>
                <strong class="d-lg-block d-none">Actions</strong>
              </base-button>

              <div
                class="dropdown-item"
                @click="openReservationHistory(reservationId, bookingNumber)"
              >
                <span class="icon-action">
                  <i class="flaticon-wall-clock-1 text-blue"></i>
                  View History
                </span>
              </div>
              <div
                class="dropdown-item"
                v-if="
                  canUserChangeStatus &&
                    ['ON_HOLD'].includes(reservation.status)
                "
                @click="confirmBooking(reservationId, otaConfirmBookingById)"
              >
                <span class="icon-action">
                  <i class="flaticon-bold-check-3 text-confirmed"> </i>
                  Confirm
                </span>
              </div>
              <div
                class="dropdown-item"
                v-if="
                  canUserMarkBookingAsPaid &&
                    ['ON_HOLD', 'CONFIRMED'].includes(reservation.status)
                "
                @click="
                  handlerMarkReservationsAsPaid(
                    [
                      {
                        _id: reservationId,
                        send_payment_link: paymentLinkStatus,
                        payment: payment,
                        ...reservation
                      }
                    ],
                    markReservationsAsPaidById
                  )
                "
              >
                <span class="icon-action">
                  <i class="flaticon-web-credit-card text-confirmed"></i>
                  Mark as Pay
                </span>
              </div>
              <div
                class="dropdown-item"
                v-if="
                  canUserChangeStatus &&
                    ['ON_HOLD', 'CONFIRMED'].includes(reservation.status)
                "
                @click.stop="
                  otaCancelBooking(reservationId, otaCancelBookingById)
                "
              >
                <span class="icon-action">
                  <i class="flaticon-remove text-cancelled"></i> Cancel
                </span>
              </div>

              <div class="dropdown-divider"></div>

              <div
                class="dropdown-item"
                v-if="canUserSendPaymentLink"
                @click="
                  handlerSendPaymentLink(
                    [
                      {
                        _id: reservationId,
                        send_payment_link: paymentLinkStatus,
                        payment: payment,
                        ...reservation
                      }
                    ],
                    customer,
                    sendPaymentLinkToCustomer
                  )
                "
              >
                <span class="icon-action">
                  <i class="flaticon-email text-orange"></i> Send Payment Link
                </span>
              </div>

              <div
                class="dropdown-item"
                @click="
                  resendNotifications(
                    reservationId,
                    reservation.status,
                    'Experiences',
                    false,
                    resendEmailNotificationByBookingId
                  )
                "
              >
                <span class="icon-action">
                  <i class="flaticon-envelope text-orange"></i> Resend Email
                </span>
              </div>

              <div
                class="dropdown-item"
                v-if="canDownloadVoucher(reservation.status)"
                @click="
                  downloadPDFType(
                    reservationId,
                    bookingNumber,
                    true,
                    'voucher',
                    reservation.agent ? reservation.agent : reservation.customer
                  )
                "
              >
                <span class="icon-action">
                  <i class="flaticon-web-bill-2"></i> Download Voucher
                </span>
              </div>
              <div
                class="dropdown-item"
                v-if="['CONFIRMED'].includes(reservation.status)"
                @click.stop="
                  downloadTickets(
                    reservationId,
                    reservation.agent
                      ? reservation.agent
                      : reservation.customer,
                    bookingNumber
                  )
                "
              >
                <span class="icon-action">
                  <i class="flaticon-web-tickets"></i>Download Tickets
                </span>
              </div>
            </base-dropdown>

            <base-button
              type="outline-neutral"
              @click="mode = 'edit'"
              class="min-button ml-2 no-mb"
              v-if="mode === 'view' || mode === 'list'"
            >
              <i class="flaticon-pencil icon-no-margin"></i>

              <strong class="d-lg-block d-none">Edit</strong>
            </base-button>

            <base-button
              type="primary"
              @click="saveReservation()"
              :disabled="isReservationUpdated"
              class="min-button ml-2 no-mb"
              v-if="mode === 'edit' && canUserUpdate"
            >
              <i class="flaticon-floppy-disk icon-no-margin"></i>
              <strong class="d-lg-block d-none">Save</strong>
            </base-button>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mb-5 ">
      <div class="row">
        <div
          v-if="['EXPIRED'].includes(reservation.status)"
          class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mb-2"
        >
          <base-alert type="warning" class="mb-0 info-min">
            <i class="flaticon-warning mr-1"></i> The quote period for this
            reservation has expired. You can resume the reservation once it has
            been re-quoted.
          </base-alert>
        </div>

        <div v-show="mode === 'view'" class="forms ticket">
          <div class="col-12">
            <div class="row">
              <div class="col-xl-8 col-lg-12 col-md-12 col-sm-12 col-12">
                <div class="row">
                  <div class="col-xl-12 col-lg-12 box-ticket">
                    <div class="row">
                      <div class="col-xl-12">
                        <div class="header-ticket">
                          <div class="row">
                            <div
                              class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 alinmov1 align-self-center"
                            >
                              <span class="capitalize title-passenger">
                                {{ getTitleByGender(booking.contact.gender) }}
                                {{ booking.contact.fullName }}</span
                              >

                              <span class="date-time">
                                {{ getTravelDate(availabilityId) }}
                                <template
                                  v-if="availabilityType !== 'OPENING_HOURS'"
                                >
                                  at
                                  {{ getStartTime(availabilityId) }}
                                </template>
                              </span>
                            </div>

                            <div
                              class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 alinmov2 mt-sm-0 mt-3 align-self-center "
                            >
                              <span class="label-total">
                                TOTAL CHARGES:
                              </span>

                              <span
                                class="price-total"
                                :class="pricing.retail < 0 ? 'loss-alert' : ''"
                              >
                                {{
                                  getCurrenSymbolByCurrency(
                                    product.defaultCurrency
                                  )
                                }}
                                {{ getFormatPrice(pricing) }}
                                {{ pricing.currency }}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-xl-12 col-lg-12">
                        <div class="card-ticket">
                          <div class="box box-services">
                            <div class="row">
                              <div
                                class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
                              >
                                <div class="row card-experience-reserv">
                                  <div
                                    class="col-xl-2 col-md-2 col-sm-3 col-12 align-self-center alinmov4"
                                  >
                                    <LazyImage
                                      :src="getProductImages(product)"
                                      alt="ProductImage"
                                      imgClasses="img-experiences-min"
                                    />
                                  </div>
                                  <div
                                    class="col-xl-10 col-lg-10 col-md-10 col-sm-9 col-12 align-self-center "
                                  >
                                    <a
                                      :href="
                                        `/experiences/ventrata/${productId}?providerId=${product.providerId}`
                                      "
                                      target="_blank"
                                      class="link-experiences mt-sm-0 mt-3"
                                    >
                                      {{ product.title }}
                                      <i class="flaticon-link ml-1 f-14"></i>
                                    </a>

                                    <div class="descrip">
                                      <p
                                        class="short-description"
                                        v-if="product.shortDescription"
                                      >
                                        {{ product.shortDescription }}
                                      </p>

                                      <p
                                        class="short-description"
                                        v-else="product.shortDescription"
                                      >
                                        An experience that will make you enjoy
                                        incredible moments and create
                                        unforgettable memories, transforming the
                                        way you see the world.
                                      </p>

                                      <div class="d-flex">
                                        <i class="flaticon-clock mr-2"></i>
                                        <span>
                                          {{ getDurationByOption(option) }}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="box border-bottom" v-if="meetingPoint">
                            <div class="row">
                              <div class="col-12 mt-lg-0 mt-md-3 mt-sm-3">
                                <div class="address-content">
                                  <div class="icon-pick">
                                    <i class="flaticon-start text-primary"></i>
                                  </div>

                                  <div class="content">
                                    <span
                                      class="title-one"
                                      v-if="meetingLocalDateTime"
                                    >
                                      Pickup:
                                      {{ getTime(meetingLocalDateTime) }}
                                    </span>
                                    <span class="title-two">
                                      {{ meetingPoint }}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div
                            class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 supplier-box"
                          >
                            <div class="item-content-2">
                              <label>Destination: </label
                              ><span class="ml-1">
                                {{ product.location }}
                              </span>
                              <span
                                class="mx-2 no-mobile-xxs"
                                v-if="product.destination"
                                >|</span
                              >
                            </div>

                            <div
                              class="item-content-2"
                              v-if="product.destination"
                            >
                              <label>Supplier: </label
                              ><span class="ml-1">
                                {{ product.destination.contact.name }}
                              </span>
                            </div>
                          </div>

                          <div class="box">
                            <div class="row">
                              <div
                                class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12"
                              >
                                <div class="data-block">
                                  <span class="title-block">PAX</span>
                                  <span class="content-block">{{
                                    getLabelPax(unitItems)
                                  }}</span>
                                </div>
                              </div>

                              <div
                                class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12"
                              >
                                <div class="data-block">
                                  <span class="title-block">PAX Full Name</span>
                                  <span class="content-block">
                                    {{
                                      getTitleByGender(booking.contact.gender)
                                    }}
                                    {{ booking.contact.fullName }}</span
                                  >
                                </div>
                              </div>

                              <div
                                class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12"
                              >
                                <div class="data-block">
                                  <span class="title-block"
                                    >Contact Number</span
                                  >
                                  <span class="content-block"
                                    >{{ booking.contact.phone }}
                                    <el-tooltip
                                      content="Copy"
                                      placement="bottom"
                                    >
                                      <span
                                        class="curp ml-2"
                                        v-clipboard:copy="booking.contact.phone"
                                        v-clipboard:success="onCopy"
                                        v-clipboard:error="onErrorCopy"
                                      >
                                        <i
                                          class="flaticon-copy link ml-0"
                                        ></i></span></el-tooltip
                                  ></span>
                                </div>
                              </div>

                              <div
                                class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12"
                                v-if="customer"
                              >
                                <div class="data-block mb-0">
                                  <span class="title-block">Customer</span>
                                  <span class="content-block">
                                    <a
                                      class="capitalize"
                                      :href="
                                        [
                                          'travel_agency',
                                          'travel_access'
                                        ].includes(customer.type)
                                          ? `/partners/${customer._id}`
                                          : `/customers/${customer._id}`
                                      "
                                      target="_blank"
                                      >{{ customer.first_name }}
                                      {{ customer.last_name }}
                                    </a>
                                    <span class="type-card">
                                      -
                                      {{
                                        formatClientType(customer.type)
                                      }}</span
                                    >
                                  </span>
                                </div>
                              </div>

                              <div
                                class="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12"
                                v-if="booking.pickupNotes"
                              >
                                <div class="data-block mb-0">
                                  <span class="title-block">Pickup Notes</span>
                                  <span
                                    class="content-block"
                                    v-if="booking.pickupNotes"
                                    >{{ booking.pickupNotes }}</span
                                  >
                                  <span class="content-block " v-else>
                                    NONE
                                  </span>
                                </div>
                              </div>

                              <div
                                class="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12"
                              >
                                <div class="data-block mb-0">
                                  <span class="title-block">Notes</span>
                                  <span
                                    class="content-block"
                                    v-if="booking.contact.notes"
                                    >{{ booking.contact.notes }}</span
                                  >
                                  <span class="content-block " v-else>
                                    NONE
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <FadeTransition :duration="300" mode="out-in">
                        <div class="col-xl-12 col-12 mt-2 ">
                          <div class="card mb-0 pb-0">
                            <div class="data-block mb-2">
                              <span class="title-block f-14">Tickets</span>
                            </div>
                            <div>
                              <b-table
                                hover
                                :items="tickets"
                                :fields="ticketTableHeaders"
                                sort-by.sync="type"
                                sort-desc.sync="true"
                                select-mode="single"
                                ref="tabletickets"
                                sort-icon-left
                                responsive
                                show-empty
                                empty-filtered-text="There are no records matching your request"
                                empty-text="There are no records to show"
                              >
                                <template #cell(ticketid)="data">
                                  <span class="text-uppercase">
                                    {{ data.item.supplierReference }}
                                  </span>
                                </template>

                                <template #cell(type)="data">
                                  {{ data.item.internalName }}
                                </template>

                                <template #cell(price)="data">
                                  <span>
                                    {{
                                      getCurrenSymbolByCurrency(
                                        data.item.pricing.currency
                                      )
                                    }}
                                    {{
                                      getPriceByCurrencyPrecision(
                                        data.item.pricing.retail,
                                        data.item.pricing.currencyPrecision
                                      )
                                    }}
                                    {{ data.item.pricing.currency }}
                                  </span>
                                </template>

                                <template #cell(status)="data">
                                  <span
                                    class="badge-status text-status f12i"
                                    v-bind:class="
                                      getStatusClass(data.item.status)
                                    "
                                  >
                                    {{
                                      getReservationStatusFormat(
                                        data.item.status
                                      )
                                    }}
                                  </span>
                                </template>
                              </b-table>
                            </div>
                          </div>
                        </div>
                      </FadeTransition>

                      <div
                        class="col-12 mt-2"
                        v-if="product.cancellationPolicy"
                      >
                        <div class="card pb-3 mb-0">
                          <div class="data-block mb-2">
                            <span class="title-block f-14"
                              >Cancellations Policies</span
                            >
                          </div>

                          <ul class="cancellations-list">
                            <li>
                              {{ product.cancellationPolicy }}
                            </li>
                          </ul>
                        </div>
                      </div>

                      <div class="col-xl-12 col-12 mt-2">
                        <div class="card box-created">
                          <span>
                            <strong>Created: </strong>
                            {{ getDate(createdAt) }} at
                            {{ getTime(createdAt) }}
                            | By <strong>{{ responsibleName }}</strong
                            >-{{ responsiblePosition }}
                          </span>
                          <span
                            ><strong>Origin:</strong>
                            {{ getSourceOrigin(reservation.source) }} |
                            <strong> Service Provider:</strong>
                            {{ getServiceProvider(reservation.source) }}</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-4 col-lg-12 pl-xl-0">
                <base-alert
                  type="warning"
                  class="text-center f-18"
                  v-if="reservation.status === 'ON_HOLD' && utcExpiresAt"
                >
                  <i class="flaticon-history-1 mr-1"></i> Expires in
                  <Countdown :date="utcExpiresAt" type="lg" labels />
                </base-alert>

                <Charges
                  :serviceType="'experience'"
                  :defaultCurrency="product.defaultCurrency"
                  :pricing="pricing"
                  :commissions="reservation.commissions"
                />

                <div class="row">
                  <div
                    class="col-xl-12 col-lg-6 col-md-6 col-sm-12 col-12 box-flex"
                  >
                    <div class="card py-3">
                      <div class="row">
                        <div class="col-12">
                          <h2 class="subtitle mb-1">Payment Details</h2>

                          <div class="item-selected">
                            <span>
                              <strong>Payment Type: </strong>
                              {{
                                formatPaymentType(reservation.payment_type)
                              }}</span
                            >
                          </div>

                          <div
                            class="item-selected"
                            v-if="reservation.invoice_number"
                          >
                            <span>
                              <strong>Invoice N°: </strong>
                              {{ reservation.invoice_number }}
                              <el-tooltip content="Copy" placement="bottom">
                                <span
                                  class="curp ml-2"
                                  v-clipboard:copy="reservation.invoice_number"
                                  v-clipboard:success="onCopy"
                                  v-clipboard:error="onErrorCopy"
                                >
                                  <i class="flaticon-copy link ml-0"></i>
                                </span> </el-tooltip
                            ></span>
                          </div>

                          <div
                            class="item-selected"
                            v-if="
                              transactionId || reservation.payment_reference
                            "
                          >
                            <span v-if="transactionId">
                              <strong>Payment Reference N°: </strong>
                              {{ transactionId }}
                              <el-tooltip content="Copy" placement="bottom">
                                <span
                                  class="curp ml-2"
                                  v-clipboard:copy="transactionId"
                                  v-clipboard:success="onCopy"
                                  v-clipboard:error="onErrorCopy"
                                >
                                  <i class="flaticon-copy link ml-0"></i>
                                </span> </el-tooltip
                            ></span>

                            <span v-if="reservation.payment_reference">
                              <strong>Payment Reference N°: </strong>
                              {{ reservation.payment_reference }}
                              <el-tooltip content="Copy" placement="bottom">
                                <span
                                  class="curp ml-2"
                                  v-clipboard:copy="
                                    reservation.payment_reference
                                  "
                                  v-clipboard:success="onCopy"
                                  v-clipboard:error="onErrorCopy"
                                >
                                  <i class="flaticon-copy link ml-0"></i>
                                </span> </el-tooltip
                            ></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-xl-12 col-lg-6 col-md-6 col-sm-12 col-12 box-flex"
                    v-if="
                      reservation.booking_reference || reservation.deal_number
                    "
                  >
                    <div class="card card py-3">
                      <h2 class="subtitle mb-1">External References</h2>

                      <div
                        class="item-selected"
                        v-if="reservation.booking_reference"
                      >
                        <span>
                          <strong>Reservation Reference: </strong>
                          {{ reservation.booking_reference }}
                          <el-tooltip content="Copy" placement="bottom">
                            <span
                              class="curp ml-2"
                              v-clipboard:copy="reservation.booking_reference"
                              v-clipboard:success="onCopy"
                              v-clipboard:error="onErrorCopy"
                            >
                              <i class="flaticon-copy link ml-0"></i>
                            </span> </el-tooltip
                        ></span>
                      </div>

                      <div class="item-selected" v-if="reservation.deal_number">
                        <span>
                          <strong>Zoho Deal Number: </strong>
                          {{ reservation.deal_number }}
                          <el-tooltip content="Copy" placement="bottom">
                            <span
                              class="curp ml-2"
                              v-clipboard:copy="reservation.deal_number"
                              v-clipboard:success="onCopy"
                              v-clipboard:error="onErrorCopy"
                            >
                              <i class="flaticon-copy link ml-0"></i>
                            </span> </el-tooltip
                        ></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-12" v-show="mode === 'list'">
          <div class="card">
            <div class="review">
              <div class="row">
                <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 col-12 mb-4">
                  <h4 class="subtitle mb-2">Address / Date & Time</h4>
                  <div>
                    <label class="form-control-label pr-1"
                      >Reservation ID:</label
                    >
                    <span>{{ bookingNumber }}</span>
                  </div>

                  <div>
                    <label class="form-control-label pr-1"
                      >Reservation Type:</label
                    >
                    <span>Experience</span>
                  </div>

                  <div>
                    <label class="form-control-label pr-1">Duration:</label>
                    <span>{{ getDurationByOption(option) }}</span>
                  </div>

                  <div>
                    <label class="form-control-label pr-1">Experience:</label>
                    <span>{{ product.title }}</span>
                  </div>

                  <div>
                    <label class="form-control-label pr-1">Date:</label>
                    <span> {{ getDate(availabilityId) }}</span>
                  </div>
                  <div v-if="availabilityType !== 'OPENING_HOURS'">
                    <label class="form-control-label pr-1">Schedule:</label>
                    <span> {{ getTime(availabilityId) }}</span>
                  </div>

                  <div>
                    <label class="form-control-label pr-1">PAX N°:</label>
                    <span>{{ getLabelPax(unitItems) }}</span>
                  </div>

                  <div v-if="meetingPoint">
                    <label class="form-control-label pr-1">Pickup:</label>
                    <span>{{ meetingPoint }}</span>
                  </div>

                  <div v-if="booking.pickupNotes">
                    <label class="form-control-label pr-1">Pickup Notes:</label>
                    <span class="break-word">{{ booking.pickupNotes }}</span>
                  </div>

                  <div>
                    <label class="form-control-label pr-1">Notes:</label>
                    <span class="break-word" v-if="booking.contact.notes">{{
                      booking.contact.notes
                    }}</span>
                    <span class="break-word" v-else>NONE</span>
                  </div>
                </div>

                <div
                  class="col-xl-3 col-lg-6 col-md-6 col-sm-12 col-12 mb-4"
                  v-if="product.destination"
                >
                  <h4 class="subtitle mb-2">Destination / Supplier</h4>

                  <div>
                    <label class="form-control-label pr-1">Supplier:</label>
                    <span>{{ product.destination.contact.name }}</span>
                  </div>
                  <div>
                    <label class="form-control-label pr-1">Destination:</label>
                    <span>{{ product.location }}</span>
                  </div>
                </div>

                <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 col-12 mb-4">
                  <h4 class="subtitle mb-2">Customer / PAX</h4>

                  <div>
                    <label class="form-control-label pr-1">Customer:</label>

                    <span class="capitalize" v-if="customer"
                      >{{ customer.first_name }} {{ customer.last_name }} -
                      {{ formatClientType(customer.type) }}</span
                    >
                  </div>

                  <div>
                    <label class="form-control-label pr-1"
                      >PAX Full Name:</label
                    >
                    <span class="capitalize">
                      {{ getTitleByGender(booking.contact.gender) }}
                      {{ booking.contact.fullName }}
                    </span>
                  </div>
                  <div>
                    <label class="form-control-label pr-1">PAX Email:</label>
                    <span>{{ booking.contact.email }}</span>
                  </div>

                  <div>
                    <label class="form-control-label pr-1"
                      >Contact Number:</label
                    >
                    <span>{{ booking.contact.phone }}</span>
                  </div>
                </div>

                <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 col-12 mb-4">
                  <h4 class="subtitle mb-2">Pricing / Payment</h4>
                  <div>
                    <label class="form-control-label pr-1"
                      >Total Charges:</label
                    >
                    <span>
                      {{ getCurrenSymbolByCurrency(product.defaultCurrency) }}
                      {{ getFormatPrice(pricing) }}
                      {{ pricing.currency }}
                    </span>
                  </div>

                  <div>
                    <label class="form-control-label pr-1">Payment Type:</label>
                    <span>
                      {{ formatPaymentType(reservation.payment_type) }}</span
                    >
                  </div>

                  <div v-if="reservation.invoice_number">
                    <label class="form-control-label pr-1">Invoice N°:</label>
                    <span>{{ reservation.invoice_number }}</span>
                  </div>

                  <div v-if="transactionId">
                    <label class="form-control-label pr-1"
                      >Payment Reference N°:</label
                    >
                    <span> {{ transactionId }}</span>
                  </div>

                  <div v-if="reservation.payment_reference">
                    <label class="form-control-label pr-1"
                      >Payment Reference N°:</label
                    >
                    <span> {{ reservation.payment_reference }}</span>
                  </div>

                  <div v-if="reservation.deal_number">
                    <label class="form-control-label pr-1"
                      >Zoho Deal Number:</label
                    >
                    <span> {{ reservation.deal_number }}</span>
                  </div>

                  <div v-if="reservation.booking_reference">
                    <label class="form-control-label pr-1"
                      >Reservation Reference:</label
                    >
                    <span>{{ reservation.booking_reference }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-show="mode === 'edit'" class="forms">
          <div class="col-xl-12 col-lg-12 forms ">
            <div class="row">
              <div class="col-xl-8 col-lg-12 col-md-12 col-sm-12 col-12">
                <div class="row">
                  <div class="col-xl-12">
                    <ProductCard
                      :product="product"
                      source="VENTRATA"
                      :productId="productId"
                    />
                  </div>

                  <div class="col-xl-12">
                    <div class="card">
                      <h2 class="subtitle mb-4">Reservation Info</h2>
                      <div class="row">
                        <div
                          class="col-xl-7 col-lg-6 col-md-6 col-sm-12 col-12"
                        >
                          <div class="row">
                            <div
                              class="col-xl-12 mb-3"
                              v-if="product.options.length > 1"
                            >
                              <label for="passengers" class="title-label ml-0"
                                ><span class="markrequired">*</span>
                                Options</label
                              >

                              <div class="internal-box box-options">
                                <div
                                  class="row item-options"
                                  v-for="(item, index) in product.options"
                                  :value="item.id"
                                  :key="`${index}`"
                                >
                                  <input
                                    type="radio"
                                    :id="index"
                                    name="options"
                                    class="radio-input"
                                    v-model="booking.optionId"
                                    :value="item.id"
                                  />
                                  <div
                                    class="row-options"
                                    :class="{
                                      active: booking.optionId === item.id
                                    }"
                                    @click="selectOption(item)"
                                  >
                                    <span class="title">{{
                                      item.internalName
                                    }}</span>
                                    <span class="description">{{
                                      item.shortDescription
                                    }}</span>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div class="col-xl-12 mb-4">
                              <div
                                class="internal-box box-passengers"
                                :class="{
                                  'is-invalid': $v.booking.units.$error
                                }"
                              >
                                <label for="passengers" class="title-label ml-0"
                                  ><span class="markrequired">*</span>
                                  PAX</label
                                >

                                <div
                                  v-if="option"
                                  class="row item-passengers"
                                  v-for="(unit, index) in optionUnits"
                                  :value="unit.title"
                                  :key="index"
                                >
                                  <div
                                    class="col-lg-5 col-md-5 col-sm-5 col-4 align-self-center pr-0"
                                  >
                                    <span class="title"
                                      >{{ unit.internalName }}
                                    </span>
                                    <span class="age">{{ unit.subtitle }}</span>
                                  </div>
                                  <div
                                    class="col-lg-7 col-md-7 col-sm-7 col-8 align-self-center"
                                  >
                                    <ul class="selpass">
                                      <li v-if="unit.pricingFrom">
                                        <span
                                          class="price"
                                          :class="
                                            unit.pricing.retail !==
                                            unit.pricing.original
                                              ? 'text-success'
                                              : ''
                                          "
                                        >
                                          {{
                                            getCurrenSymbolByCurrency(
                                              product.defaultCurrency
                                            )
                                          }}
                                          {{
                                            getPriceByCurrencyPrecision(
                                              unit.pricing.retail,
                                              unit.pricing.currencyPrecision
                                            )
                                          }}
                                          {{ product.defaultCurrency }}
                                        </span>
                                        <span
                                          class="price with-discount"
                                          v-if="
                                            unit.pricing.retail !==
                                              unit.pricing.original
                                          "
                                        >
                                          {{
                                            getCurrenSymbolByCurrency(
                                              product.defaultCurrency
                                            )
                                          }}
                                          {{
                                            getPriceByCurrencyPrecision(
                                              unit.pricing.original,
                                              unit.pricing.currencyPrecision
                                            )
                                          }}
                                          {{ product.defaultCurrency }}</span
                                        >
                                      </li>
                                      <li></li>
                                      <li>
                                        <base-button
                                          class="d-sm-block d-none"
                                          outline
                                          type="secondary"
                                          @click="
                                            subtractPAX(
                                              unit,
                                              units[index].quantity
                                            )
                                          "
                                          >-</base-button
                                        >
                                      </li>
                                      <li>
                                        <BaseNumberInput
                                          v-model.number="units[index].quantity"
                                          mode="integer"
                                          :id="index"
                                          name="passengersCount"
                                          class="w-70px mb-0 no-spin-buttons"
                                        />
                                      </li>
                                      <li>
                                        <base-button
                                          class="d-sm-block d-none"
                                          outline
                                          type="primary"
                                          @click="
                                            addPAX(unit, units[index].quantity)
                                          "
                                          >+</base-button
                                        >
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                              <small
                                class="invalid-feedback"
                                v-if="$v.booking.units.$error"
                              >
                                Select at least one participant
                              </small>
                            </div>

                            <div
                              class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mb-4"
                              v-if="pickupPoints.length > 0"
                            >
                              <label
                                for="passengers"
                                class="title-label ml-0"
                                :class="{
                                  'is-invalid': $v.booking.pickupPointId.$error
                                }"
                                ><span class="markrequired">*</span>
                                Pickup</label
                              >

                              <div
                                class="internal-box box-options "
                                :class="{
                                  'is-invalid': $v.booking.pickupPointId.$error
                                }"
                              >
                                <span>{{ pickupMessage }}</span>
                                <div
                                  class="row item-options"
                                  v-for="(item, index) in pickupPoints"
                                  :key="`${index}`"
                                >
                                  <div
                                    class="row-options d-flex align-items-center"
                                    :class="{
                                      active: booking.pickupPointId === item.id
                                    }"
                                    @click="selectPickup(item)"
                                  >
                                    <i
                                      class="flaticon-pin d-inline-flex mr-2"
                                    ></i>
                                    <div class="d-inline-block">
                                      <span class="title">{{
                                        item.address
                                      }}</span>
                                      <span class="description">{{
                                        item.name
                                      }}</span>
                                    </div>
                                  </div>
                                </div>

                                <div class="col-12 p-0 mt-4 no-invalid">
                                  <label for="passengers" class="title-label">
                                    Pickup Notes</label
                                  >
                                  <el-input
                                    v-model="booking.pickupNotes"
                                    placeholder="Pickup Notes"
                                    id="Pickup Notes"
                                    name="Pickup Notes"
                                    maxlength="200"
                                    type="textarea"
                                    :autosize="{ minRows: 1, maxRows: 10 }"
                                    show-word-limit
                                  >
                                  </el-input>
                                </div>
                              </div>
                              <small
                                class="invalid-feedback"
                                v-if="$v.booking.pickupPointId.$error"
                              >
                                Select a Pickup
                              </small>
                            </div>
                          </div>
                        </div>

                        <div
                          class="col-xl-5 col-lg-6 col-md-6 col-sm-12 col-12"
                        >
                          <div class="row">
                            <div
                              class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mb-4"
                            >
                              <div
                                class="internal-box no-plr"
                                :class="{
                                  'is-invalid': $v.booking.travelDate.$error
                                }"
                              >
                                <label for="time" class="title-label"
                                  ><span class="markrequired">*</span>
                                  Date
                                </label>
                                <base-input
                                  label=""
                                  markrequired
                                  inputClasses="calendar-box"
                                >
                                  <flat-picker
                                    slot-scope="{ focus, blur }"
                                    @on-open="focus"
                                    @on-close="blur"
                                    @on-change="selectTravelDateInCalendar"
                                    @on-month-change="debouncedSelectMonth"
                                    :config="
                                      getFlatPickerSettings(booking.travelDate)
                                    "
                                    class="input-custom disabled d-none"
                                    v-model="booking.travelDate"
                                    id="date"
                                    name="date"
                                    placeholder="Date"
                                    ref="datepicker"
                                  ></flat-picker>
                                </base-input>
                              </div>
                              <small
                                class="invalid-feedback"
                                v-if="$v.booking.travelDate.$error"
                              >
                                Select a Date
                              </small>
                            </div>
                            <div
                              class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mb-3"
                              v-if="availability.status"
                            >
                              <label for="time" class="title-label"
                                ><span class="markrequired">*</span>Schedule
                              </label>

                              <div
                                class="internal-box box-times "
                                :class="{
                                  'is-invalid':
                                    $v.booking.availabilityId.$error,
                                  max: hasMoreThanFiveDates(
                                    availability.options
                                  )
                                }"
                              >
                                <template
                                  v-if="availableTimeRequest === 'PENDING'"
                                >
                                  <div class="text-center p-4">
                                    <h4 class="mb-0">
                                      <strong
                                        >Looking for available times...</strong
                                      >
                                    </h4>
                                    <div id="loaderInner" class="my-3">
                                      <span></span>
                                      <span></span>
                                      <span></span>
                                      <span></span>
                                      <span></span>
                                      <span></span>
                                      <span></span>
                                      <span></span>
                                      <span></span>
                                    </div>
                                  </div>
                                </template>
                                <template v-else>
                                  <base-alert
                                    type="info"
                                    class="info-min mt-1 mb-0"
                                    v-if="
                                      allIntervalsEmpty(availability.options)
                                    "
                                  >
                                    <i class="flaticon-warning mr-1"></i>
                                    Schedules not available for the selected
                                    date
                                  </base-alert>

                                  <div
                                    class="item-times"
                                    v-for="item in availability.options"
                                  >
                                    <div
                                      v-if="
                                        item.dates.length &&
                                          item.intervalType !== 'ALL_DAY'
                                      "
                                    >
                                      <span class="group"
                                        >{{ item.intervalName }}
                                      </span>
                                      <div class="box-time box-flex">
                                        <div
                                          class="item-boxes"
                                          v-for="option in item.dates"
                                        >
                                          <div
                                            class="box-hour mb-0"
                                            :class="{
                                              active:
                                                booking.availabilityId ===
                                                option.id
                                            }"
                                            @click="
                                              selectAvailabilityId(option)
                                            "
                                          >
                                            <span class="hour">{{
                                              getOptionTime(option.id)
                                            }}</span>
                                            <span
                                              class="quantity"
                                              :class="
                                                option.status === 'SOLD_OUT'
                                                  ? 'text-danger'
                                                  : ''
                                              "
                                              >{{ getCapacity(option) }}
                                            </span>
                                            <span
                                              class="price"
                                              v-if="
                                                option.pricing.retail > 0 &&
                                                  option.status !== 'SOLD_OUT'
                                              "
                                            >
                                              {{
                                                getCurrenSymbolByCurrency(
                                                  option.pricing.currency
                                                )
                                              }}
                                              {{
                                                getFormatPrice(option.pricing)
                                              }}
                                              {{ option.pricing.currency }}
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="box-time box-flex" v-else>
                                      <div
                                        class="item-boxes"
                                        v-for="option in item.dates"
                                      >
                                        <div class="box-hour mb-0">
                                          <span class="hour">All Day</span>
                                          <span class="quantity"
                                            >{{ getCapacity(option) }}
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </template>
                              </div>
                              <small
                                class="invalid-feedback"
                                v-if="$v.booking.availabilityId.$error"
                              >
                                Select a Schedule
                              </small>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Customer / PAX -->
                  <div class="col-xl-12">
                    <div class="card">
                      <h2 class="subtitle mb-4">Customer / PAX</h2>
                      <div class="row">
                        <div
                          class="col-xl-6 col-lg-6 col-md-7 col-sm-8 col-9 no-margin mb-4"
                        >
                          <WSelect
                            label="Customer"
                            v-bind:class="{
                              'is-invalid': $v.reservation.customer.$error
                            }"
                            filterable
                            remote
                            :remote-method="getCustomer"
                            :loading="loading"
                            placeholder="Enter Name Customer"
                            v-model="$v.reservation.customer.$model"
                            id="customer"
                            name="customer"
                            @input="selectCustomer"
                            no-data-text="Search by Customer"
                            clearable
                            markrequired
                          >
                            <el-option
                              v-for="(customer, index) in customers"
                              :value="customer._id"
                              :label="getCustomerName(customer)"
                              :key="index"
                            >
                              <div class="row">
                                <div class="col-7">
                                  <span
                                    class="role-table"
                                    v-if="isCompany(customer.type)"
                                    >{{ customer.company_name }}</span
                                  >
                                  <span
                                    >{{ customer.first_name }}
                                    {{ customer.last_name }}</span
                                  >
                                </div>
                                <div class="col-5 text-right hide-data">
                                  <span class="coin-right">{{
                                    formatClientType(customer.type)
                                  }}</span>
                                </div>
                              </div>
                            </el-option>
                          </WSelect>
                          <small
                            class="invalid-feedback"
                            v-if="$v.reservation.customer.$error"
                            >Enter a Customer</small
                          >

                          <div v-if="copyData" class="text-right">
                            <base-button
                              class="linkfill"
                              @click="copyDataCustomer"
                              >+ Fill Customer Data</base-button
                            >
                          </div>
                        </div>
                        <AddCustomer
                          :show="modalCustomer"
                          @closeNewCustomerModal="closeNewCustomerModal"
                          @customer="addCustomerInOptions"
                        />

                        <div class="col-xl-4 col-lg-4 col-md-3 col-sm-4 col-3">
                          <base-button
                            @click="modalCustomer = true"
                            class="min-button"
                            type="outline-neutral"
                          >
                            <i
                              class="flaticon-plus mr-1 d-sm-inline-block d-none"
                            ></i>
                            <span class=" d-sm-inline-block d-none">
                              Add New</span
                            >
                            <span class="d-sm-none d-inline-block"> Add</span>
                          </base-button>
                        </div>

                        <div class="col-xl-2 d-xl-block d-lg-none"></div>

                        <div
                          class="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-12 form-group"
                        >
                          <label for="title" class="title-label">Gender</label>

                          <b-form-group
                            v-slot="{ ariaDescribedby }"
                            class="mb-0"
                          >
                            <b-form-radio-group
                              v-model="booking.contact.gender"
                              @input="handlePassangerChange"
                              :aria-describedby="ariaDescribedby"
                              id="radio-gender"
                              name="radio-gender"
                              buttons
                              button-variant="outline-neutral"
                              size="md"
                            >
                              <b-form-radio value="male" class="pc-4"
                                >Mr.</b-form-radio
                              >
                              <b-form-radio value="female" class="pc-4"
                                >Mrs.</b-form-radio
                              >
                              <b-form-radio value="other" class="pc-4"
                                >Mx.</b-form-radio
                              >
                            </b-form-radio-group>
                          </b-form-group>
                        </div>

                        <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
                          <base-input
                            v-model.trim="$v.booking.contact.firstName.$model"
                            @input="handlePassangerChange"
                            label="PAX First Name"
                            placeholder="PAX First Name"
                            id="first_name_Contact"
                            name="first_name_Contact"
                            format="capitalize"
                            markrequired
                            :error="
                              $v.booking.contact.firstName.$error ||
                              !$v.booking.contact.firstName.minLength ||
                              !$v.booking.contact.firstName.ValName
                                ? `Minimum 2 letters`
                                : ''
                            "
                          />
                        </div>

                        <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
                          <base-input
                            v-model.trim="$v.booking.contact.lastName.$model"
                            @input="handlePassangerChange"
                            label="PAX Last Name"
                            placeholder="PAX Last Name"
                            indexTab="17"
                            id="last_name_Contact"
                            format="capitalize"
                            name="last_name_Contact"
                            markrequired
                            :error="
                              $v.booking.contact.lastName.$error ||
                              !$v.booking.contact.lastName.minLength ||
                              !$v.booking.contact.lastName.ValName
                                ? `Minimum 2 letters`
                                : ''
                            "
                          />
                        </div>

                        <div class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12">
                          <base-input
                            v-model.trim="$v.booking.contact.email.$model"
                            @input="handlePassangerChange"
                            label="PAX Email"
                            placeholder="PAX Email"
                            id="Contact_email"
                            name="Contact_email"
                            format="lowercase"
                            :error="
                              $v.booking.contact.email.$error ||
                              !$v.booking.contact.email.minLength ||
                              !$v.booking.contact.email.email
                                ? `Enter a valid email`
                                : ''
                            "
                            markrequired
                          />
                        </div>
                        <div
                          class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12 inputphone mb-3"
                          v-bind:class="{
                            'is-invalid': $v.booking.contact.phone.$error
                          }"
                        >
                          <label class="title-label">Contact Number</label>
                          <vue-tel-input
                            v-model="contactNumber"
                            key="NumberPhone"
                            inputId="NumberPhone"
                            name="NumberPhone"
                            required
                            mode="international"
                            inputClasses="input no-err"
                            :dynamicPlaceholder="true"
                            :disabledFetchingCountry="true"
                            :validCharactersOnly="true"
                            :wrapperClasses="[
                              $v.booking.contact.phone.$error
                                ? 'is-invalid'
                                : '',
                              'mb-0'
                            ]"
                            @input="phoneInput"
                          ></vue-tel-input>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12">
                          <WSelect
                            v-model="$v.booking.contact.country.$model"
                            @input="handlePassangerChange"
                            label="Country"
                            placeholder="Enter a Country"
                            id="passenger_country"
                            name="passenger_country"
                            remote
                            filterable
                            reserve-keyword
                            :remote-method="remoteMethod"
                            :loading="loading"
                            clearable
                            :error="
                              $v.booking.contact.country.$error
                                ? `Select a Country`
                                : ''
                            "
                          >
                            <el-option
                              v-for="country in countryOptions"
                              :value="country.currency_code"
                              :label="country.name"
                              :key="country.name"
                            ></el-option>
                          </WSelect>
                        </div>

                        <div class="col-xl-12 mb-4">
                          <label class="title-label">Notes</label>
                          <el-input
                            v-model="booking.contact.notes"
                            placeholder="Notes"
                            id="Notes"
                            name="Notes"
                            maxlength="200"
                            type="textarea"
                            :autosize="{ minRows: 1, maxRows: 5 }"
                            show-word-limit
                          >
                          </el-input>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-xl-12 col-12 mt-0">
                    <div class="card box-created">
                      <span>
                        <strong>Created: </strong>
                        {{ getDate(createdAt) }} at
                        {{ getTime(createdAt) }}
                        | By <strong>{{ responsibleName }}</strong
                        >-{{ responsiblePosition }}
                      </span>
                      <span
                        ><strong>Channel:</strong>
                        Mobility Internal |
                        <strong> Service Provider:</strong> Ventrata</span
                      >
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-4 col-lg-12 pl-xl-0">
                <Charges
                  :serviceType="'experience'"
                  :defaultCurrency="product.defaultCurrency"
                  :pricing="pricing"
                  :commissions="reservation.commissions"
                />
                <div class="row">
                  <div class="col-xl-12 col-lg-6 col-md-6 col-sm-12 col-12">
                    <div class="card pb-3">
                      <h2 class="subtitle mb-3">Payment Details</h2>

                      <div class="row">
                        <div
                          class="col-xl-12 col-lg-6 col-md-6 col-sm-6 col-12"
                        >
                          <WSelect
                            placeholder="Payment Type"
                            v-model="reservation.payment_type"
                            id="paymentType"
                            name="paymentType"
                            @change="changePaymentType"
                            label="Payment Type"
                          >
                            <el-option
                              v-for="option in paymentMethods"
                              :value="option.value"
                              :label="option.label"
                              :key="option.label"
                            ></el-option>
                          </WSelect>
                        </div>

                        <div
                          class="col-xl-12 col-lg-6 col-md-6 col-sm-6 col-12"
                        >
                          <base-input
                            v-model.trim="reservation.invoice_number"
                            type="text"
                            label="Invoice Number"
                            placeholder="Invoice Number"
                            id="invoice_number"
                            name="invoice_number"
                          />
                        </div>

                        <div
                          class="col-xl-12 col-lg-12 col-md-12 col-sm-6 col-12"
                        >
                          <base-input
                            type="text"
                            label="Payment Reference N°"
                            placeholder="Payment Reference N°"
                            v-model="reservation.payment_reference"
                            id="paymentreference"
                            name="paymentreference"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-xl-12 col-lg-6 col-md-6 col-sm-12 col-12">
                    <div class="card pb-3">
                      <h2 class="subtitle mb-3">External References</h2>

                      <div class="row">
                        <div
                          class="col-xl-12 col-lg-6 col-md-12 col-sm-6 col-12"
                        >
                          <base-input
                            type="text"
                            label="Reservation Reference"
                            placeholder="Reservation Reference"
                            v-model="$v.reservation.booking_reference.$model"
                            id="booking_reference"
                            name="booking_reference"
                            indexTab="28"
                            :error="
                              $v.reservation.booking_reference.$error
                                ? `Enter maximum ${$v.reservation.booking_reference.$params.maxLength.max} characters.`
                                : ''
                            "
                          />
                        </div>

                        <div
                          class="col-xl-12 col-lg-6 col-md-12 col-sm-6 col-12"
                        >
                          <base-input
                            placeholder="Zoho Deal Number"
                            v-model.trim="$v.reservation.deal_number.$model"
                            id="deal_number"
                            name="deal_number"
                            label="Zoho Deal Number"
                            type="text"
                            :error="
                              dealNumberValidationMessage(
                                $v.reservation.deal_number
                              )
                            "
                          ></base-input>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <RequestRecipients
      :show="showRequestRecipients"
      :recipients="['NOT_NOTIFY', 'ALL', 'PASSENGER', 'CUSTOMER', 'AGENT']"
      @onPopulateRecipients="populateRecipients"
      @onCloseRequestRecipients="closeRequestRecipientsModal"
    />
    <ReservationHistory
      :show="showReservationHistory"
      :tempReservationId="tempReservationId"
      :bookingNumber="tempBookingNumber"
      @close="closeReservationHistoryModal"
    />
  </section>
</template>

<script>
// @ is an alias to /src
import { v4 as uuidv4 } from "uuid";
const Moment = require("moment");
const MomentRange = require("moment-range");
const moment = MomentRange.extendMoment(Moment);
import { mapGetters, mapActions, mapMutations } from "vuex";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { CurrenciesAPI, ReservationsAPI, VentrataAPI } from "../../../core/api";
import Swal from "sweetalert2";
import { VueTelInput } from "vue-tel-input";
import WSelect from "@/components/Select";
import AddCustomer from "../../../components/transfer/AddCustomer.vue";
import RequestRecipients from "../components/RequestRecipients.vue";
import ReservationHistory from "../components/ReservationHistory";
import Charges from "../components/ChargesExperiences";
import { helpers } from "vuelidate/lib/validators";
import Countdown from "@/components/Countdown.vue";
const ValName = helpers.regex("alphaCha", /^[a-zA-ZÑñáéíóúüüÜÁÉÍÓÚ'-\s]*$/);
import {
  required,
  alphaNum,
  minLength,
  maxLength,
  email
} from "vuelidate/lib/validators";
import {
  Tabs,
  TabPane,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  DatePicker,
  TimeSelect,
  MessageBox,
  Message
} from "element-ui";
import lodash from "lodash";
import ProductCard from "../components/ProductCard";
import PaymentStatus from "../components/PaymentStatus";
import FirstBookingBadge from "../components/FirstBookingBadge";
import { FadeTransition } from "vue2-transitions";
import debounce from "lodash.debounce";
import {
  canDownloadVoucher,
  canMarkBookingAsPaid,
  canResendBookingEmail,
  confirmBooking,
  hasBookingsWithPaymentLink,
  hasCanceledBookings,
  hasDraftBookings,
  hasExpiredBookings,
  hasPaidBookings,
  isSameUserForAllBookings,
  markReservationsAsPaid,
  otaCancelBooking,
  PAYMENT_METHODS,
  resendNotifications,
  sendPaymentLink
} from "../../../helpers/reservation.helpers";
import { calculateCommissionAmount } from "../../pricing";
import {
  goBack,
  isUserAuthorized,
  setSigOut
} from "../../../helpers/commons.helpers";
import { dealNumberValidationMessage } from "../services/validation.service";
import {
  formatClientType,
  formatPaymentType,
  formatPosition
} from "../services/format.service";
import { alphabeticallySort } from "../services/client.service";
import { TICKET_TABLE_HEADERS } from "../../../core/constants";

WSelect.computed.readonly = function() {
  const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode));
  return (
    !this.filterable ||
    this.multiple ||
    (!isIE && !this.visible && !this.remote)
  );
};

export default {
  name: "EditReservation",
  data() {
    return {
      booking: {
        productId: null,
        availabilityId: null,
        optionId: null,
        units: [],
        travelDate: "",
        pickupPointId: null,
        pickupNotes: null,
        contact: {
          firstName: "",
          lastName: "",
          fullName: "",
          email: "",
          phone: "",
          gender: "",
          type: "ADULT",
          primary: true,
          flightNumber: "",
          country: "",
          notes: ""
        }
      },
      reservation: {
        passengers: [],
        payment_type: "card",
        customer: null,
        booking_reference: "",
        payment_reference: "",
        invoice_number: "",
        owner: "admin",
        agent: null,
        metadata: {},
        deal_number: "",
        responsible: {
          type: "Users",
          ref: ""
        },
        notificaition: {
          configTag: "rhomtrip_internal",
          configRef: null
        },
        commissions: {
          payment_processor: {
            amount: 0.0,
            percentage: 0.0
          },
          platform: {
            amount: 0.0,
            percentage: 0.0
          }
        },
        source: {
          origin: "RhomTrip Internal",
          type: "INTERNAL",
          provider: "VENTRATA",
          channel: "SYSTEM",
          medium: "APP"
        },
        providerId: null
      },
      pickup_date: "",
      paymentMethods: PAYMENT_METHODS,
      bookingNumber: "",
      isFirstBooking: false,
      customer: null,
      loading: false,
      customers: [],
      reservationCopy: {},
      bookingCopy: {},
      copyData: false,
      transactionId: "",
      modalCustomer: false,
      reservationId: null,
      showReservationHistory: false,
      tempReservationId: "",
      tempBookingNumber: "",
      creditAvailable: true,
      customerId: null,
      showRequestRecipients: false,
      route: null,
      mode: "view",
      createdAt: "",
      payment: null,
      paymentLinkStatus: "",
      paymentLink: "",
      responsibleName: "",
      responsiblePosition: "",
      product: {
        title: "",
        code: "",
        country: "US",
        subtitle: "",
        description: "",
        shortDescription: "",
        pickupPoints: [],
        defaultCurrency: "",
        availableCurrencies: [""],
        inclusions: [],
        exclusions: [],
        highlights: [],
        redemptionInstructions: null,
        bookingTerms: null,
        cancellationPolicy: null,
        importantInformation: [],
        destination: null,
        faqs: [],
        coverImageUrl: "",
        bannerImageUrl: "",
        videoUrl: "",
        galleryImages: [],
        bannerImages: [],
        cancellationPolicy: null,
        options: [],
        location: "",
        categories: [],
        providerId: null
      },
      pickupMessage: "",
      datesNotAvailable: [],
      contactNumber: "",
      countryOptions: [],
      productId: null,
      option: {
        units: []
      },
      currentMonth: moment().month(),
      localDateStart: null,
      localDateEnd: null,
      availabilities: [],
      availabilityType: "",
      availability: {
        options: []
      },
      schedules: [],
      pricing: {
        currency: "",
        currencyPrecision: 0,
        includedTaxes: [],
        net: 0,
        original: 0,
        retail: 0
      },
      itinerary: [],
      pickupAvailable: false,
      pickupPoints: [],
      pickupRequired: false,
      availabilityId: null,
      units: [],
      location: "",
      unitItems: [],
      meetingPoint: null,
      meetingPointCoordinates: [],
      meetingLocalDateTime: null,
      duration: "",
      uuid: null,
      isReservationUpdated: false,
      utcExpiresAt: "",
      noImage: require("rhomtrip_assets/src/img/no-image-available.png"),
      ticketTableHeaders: TICKET_TABLE_HEADERS,
      tickets: [],
      optionUnits: [],
      commissionApplied: 0,
      providerId: null,
      availableTimeRequest: "INIT",
      debouncedSelectMonth: null,
      customer: null
    };
  },
  async created() {
    var bread = [
      {
        text: "Dashboard",
        to: "/dashboard"
      },
      {
        text: "Reservations",
        to: "/reservations"
      },
      {
        text: "Reservation Details",
        active: true
      }
    ];
    this.setItemsBread(bread);
    this.countryOptions = this.countries;
    this.reservationId = this.$route.params.id;
    this.debouncedSelectMonth = debounce(this.selectMonth, 500);
    this.setLoad(true);
    await this.initReservation(this.reservationId);
    this.customers = this.customerOptions;
    this.setLoad(false);
  },
  methods: {
    openReservationHistory(reservationId, bookingNumber) {
      this.tempReservationId = reservationId;
      this.tempBookingNumber = bookingNumber;
      this.showReservationHistory = true;
    },
    closeReservationHistoryModal() {
      this.showReservationHistory = false;
    },
    canResendBookingEmail,
    resendNotifications,
    confirmBooking,
    otaCancelBooking,
    canMarkBookingAsPaid,
    canDownloadVoucher,
    dealNumberValidationMessage,
    formatPaymentType,
    formatClientType,
    async initReservation(reservationId) {
      try {
        let { data } = await ReservationsAPI.getReservation(reservationId);
        if (data.status) {
          let reservation = data.data;
          this.populateCustomer(reservation.customer, reservation.agent);
          this.uuid = reservation.uuid;
          this.providerId = reservation.providerId;
          this.reservation.providerId = this.providerId;
          this.reservation.invoice_number = reservation.invoice_number;
          this.reservation.passengers = reservation.passengers;
          this.utcExpiresAt = reservation.utcExpiresAt;
          this.availabilityId = reservation.availabilityId;
          this.booking.availabilityId = reservation.availabilityId;
          this.booking.travelDate = this.booking.availabilityId;
          if (this.reservation.passengers.length) {
            let [passenger] = reservation.passengers;
            this.booking.contact.firstName = passenger.firstName;
            this.booking.contact.lastName = passenger.lastName;
            this.booking.contact.fullName = passenger.fullName;
            this.booking.contact.phone = passenger.phone;
            this.booking.contact.email = passenger.email;
          }

          this.contactNumber = this.booking.contact.phone;
          this.booking.contact.country = reservation.contact.country;
          this.booking.contact.notes = reservation.contact.notes;
          this.booking.pickupNotes = reservation.pickupNotes;
          this.booking.pickupPointId = reservation.pickupPointId;

          this.booking.optionId = reservation.optionId;

          this.bookingNumber = reservation.booking_number;
          this.isFirstBooking = reservation.isFirstBooking === true;
          this.transactionId =
            reservation.payment !== null && reservation.payment.transaction_id
              ? reservation.payment.transaction_id
              : "";

          this.reservation.payment_reference = reservation.payment_reference;
          this.reservation.booking_reference = reservation.booking_reference;
          this.reservation.source = reservation.source;
          this.reservation.payment_type = reservation.payment_type;
          this.reservation.status = reservation.status;
          this.reservation.deal_number = reservation.deal_number;
          this.reservation.notificaition = reservation.notificaition;
          this.reservation.responsible = reservation.responsible;
          this.reservation.commissions = lodash.cloneDeep(
            reservation.commissions
          );

          this.payment = reservation.payment;
          this.paymentLinkStatus = reservation.send_payment_link;
          this.paymentLink = reservation.payment_link;

          this.meetingPoint = reservation.meetingPoint;
          this.meetingPointCoordinates = reservation.meetingPointCoordinates;
          this.meetingLocalDateTime = reservation.meetingLocalDateTime;
          this.duration = reservation.duration;

          this.unitItems = reservation.unitItems;
          this.location = reservation.location;
          this.pricing = reservation.pricing;
          this.booking.productId = reservation.productId;
          this.productId = reservation.productId;
          this.localDateStart = this.getLocalDateStart(this.currentMonth);
          this.localDateEnd = this.getLocalDateEnd(this.currentMonth);
          //Populate product Information
          let product = await this.getProductDetails(
            reservation.productId,
            this.providerId
          );
          this.product.title = product.title || product.internalName;
          this.product.code = product.code;
          this.product.country = product.country;
          this.product.subtitle = product.subtitle;
          this.product.shortDescription = product.shortDescription;
          this.product.defaultCurrency = product.defaultCurrency;
          this.product.availableCurrencies = product.availableCurrencies;
          this.product.inclusions = product.inclusions;
          this.product.exclusions = product.exclusions;
          this.product.highlights = product.highlights;
          this.product.redemptionInstructions = product.redemptionInstructions;
          this.product.bookingTerms = product.bookingTerms;
          this.product.cancellationPolicy = product.cancellationPolicy;

          this.product.videoUrl = product.videoUrl;
          this.product.galleryImages = product.galleryImages;
          this.product.bannerImages = product.bannerImages;
          this.product.faqs = product.faqs;
          this.product.coverImageUrl = product.coverImageUrl;
          this.product.bannerImageUrl = product.bannerImageUrl;

          this.product.destination = product.destination;
          this.product.location = product.location;
          this.product.categories = product.categories;

          this.product.options = product.options;
          this.product.availabilityType = product.availabilityType;
          this.product.providerId = this.providerId;
          this.availabilityType = this.product.availabilityType;
          this.commissionApplied = await this.getCommissionsByProductId(
            this.productId
          );
          this.option = this.getDefaultOption(this.product.options);
          this.optionUnits = this.getOptionsUnitsWithPricesBycurrency(
            this.product.defaultCurrency,
            this.option.units
          );
          this.itinerary = this.option.itinerary ? this.option.itinerary : [];
          this.tickets = reservation.unitItems.map(item => {
            return {
              supplierReference: item.supplierReference,
              internalName: item.unit.internalName,
              pricing: item.pricing,
              unitType: item.unitType,
              status: item.status
            };
          });
          this.units = this.option.units.map(unit => {
            return {
              id: unit.id,
              quantity: this.unitItems.filter(e => e.unitType === unit.type)
                .length
            };
          });
          this.responsibleName = this.getResponsibleName(
            reservation.responsible
          );
          this.responsiblePosition = this.getResponsiblePosition(
            reservation.responsible
          );
          this.createdAt = reservation.created_at;
          this.booking.units = this.units.filter(unit => unit.quantity > 0);
          await this.getAvailabilityAndSchedules();
          this.reservationCopy = lodash.cloneDeep(this.reservation);
          this.bookingCopy = lodash.cloneDeep(this.booking);
          this.setLoad(false);
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation could not be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The Operation could not be completed. Please try again",
          icon: "flaticon-remove"
        });
      }
    },
    async getProductDetails(productId, providerId) {
      try {
        let { data } = await VentrataAPI.getProduct(
          productId,
          true,
          providerId
        );
        if (data) {
          return data;
        } else {
          return null;
        }
      } catch (error) {
        return null;
      }
    },
    getDefaultOption(options = []) {
      let [option] = options;
      return option;
    },
    async updatedBookingById(uuid, booking, providerId) {
      try {
        let { data } = await VentrataAPI.updatedReservationById(
          uuid,
          booking,
          providerId
        );
        if (data) {
          return data;
        } else {
          return null;
        }
      } catch (error) {
        return null;
      }
    },
    areThereChanges() {
      return !(
        lodash.isEqual(this.reservation, this.reservationCopy) &&
        lodash.isEqual(this.booking, this.bookingCopy)
      );
    },
    selectPickup(pickUp) {
      this.booking.pickupPointId = pickUp.id;
    },
    requestRecipients() {
      this.showRequestRecipients = true;
    },
    async saveReservation(route = null) {
      if (!this.$v.reservation.$invalid && !this.$v.booking.$invalid) {
        if (["ON_HOLD", "CONFIRMED"].includes(this.reservation.status)) {
          let isThereChanges = this.areThereChanges();
          if (isThereChanges) {
            this.route = route;
            this.requestRecipients();
          } else {
            this.$router.push(route ? route : "/reservations");
          }
        } else {
          this.$notify({
            type: "warning",
            title: "Important!",
            message: this.getReservationUpdateErrorMessage(
              this.reservation.status
            ),
            icon: "flaticon-warning-1"
          });
        }
      } else {
        this.$v.reservation.$touch();
        this.$v.booking.$touch();
        this.$notify({
          type: "warning",
          title: "Important!",
          message: "Please complete the required attributes",
          icon: "flaticon-warning-1"
        });
      }
    },
    async updateReservation(
      reservationId,
      reservation,
      recipients,
      reason,
      route
    ) {
      try {
        let { data } = await ReservationsAPI.otaUpdateReservation(
          reservationId,
          reservation,
          recipients,
          reason,
          this.sesion.token
        );
        this.isReservationUpdated = true;
        if (data.code === 200) {
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The reservations has been Updated",
            icon: "flaticon-check-3"
          });
          this.reservationCopy = lodash.cloneDeep(this.reservation);
          this.$router.push(route ? route : "/reservations");
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation could not be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.handleError(
          error,
          "There was an error saving your reservation, please try again"
        );
      }
    },
    requestRecipients() {
      this.openRequestRecipientsModal();
    },
    async getCustomer(input = "") {
      try {
        if (input !== "" && input.length > 2) {
          this.loading = true;
          this.customers = this.customerOptions.filter(customer => {
            let name = `${customer.first_name} ${customer.last_name}`;
            return (
              name.toLowerCase().indexOf(input.trim().toLowerCase()) > -1 ||
              customer.company_name.toLowerCase().indexOf(input.toLowerCase()) >
                -1
            );
          });
          this.loading = false;
        } else {
          this.customers = this.customerOptions;
        }
      } catch (error) {
        this.customers = this.customerOptions;
      }
    },
    handlePassangerChange() {
      let passenger = this.populatePassenger(
        lodash.cloneDeep(this.booking.contact)
      );
      this.reservation.passengers = [passenger];
    },
    copyDataCustomer() {
      if (this.customer) {
        this.booking.contact.firstName = this.customer.first_name;
        this.booking.contact.lastName = this.customer.last_name;
        this.booking.contact.fullName = `${this.customer.first_name} ${this.customer.last_name}`;
        this.booking.contact.email = this.customer.email;
        this.booking.contact.phone = this.customer.phone;
        this.contactNumber = this.customer.phone;
        this.booking.contact.gender = this.customer.gender;
        let passenger = this.populatePassenger(
          lodash.cloneDeep(this.booking.contact)
        );
        this.reservation.passengers = [passenger];
      }
    },
    handleError(error, message) {
      if (error.response) {
        let { data } = error.response;
        if (data.code === 401) {
          let auth = setSigOut(error);
          if (auth) {
            this.setSigOut(true);
          }
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation could not be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } else {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: message,
          icon: "flaticon-remove"
        });
      }
    },
    addCustomerInOptions(customer) {
      if (customer !== null) {
        this.customers.push(customer);
        this.customers = alphabeticallySort(this.customers);
        this.customer = customer;
        this.reservation.customer = customer._id;
        this.customerId = customer._id;
        this.setCustomerOptions(this.customerOptions.concat([customer]));
      }
    },
    closeNewCustomerModal(status) {
      this.modalCustomer = false;
      if (!status) {
        this.reservation.customer = this.customer._id;
      }
    },
    async selectCustomer(customerId) {
      if (customerId) {
        if (this.booking.units.length === 0) {
          this.$notify({
            type: "warning",
            title: "Important!",
            message: `We have detected that you have not selected the number of PAX`,
            icon: "flaticon-warning-1"
          });
          this.reservation.customer = null;
          this.customerId = null;
        } else {
          this.customer = this.customers.find(customer => {
            return customer._id === customerId;
          });
          this.copyData = true;
          this.populateCommission(
            this.customer,
            this.pricing,
            this.commissionApplied
          );
          if (["travel_access"].includes(this.customer.type)) {
            this.reservation.customer = this.customer.owner;
            this.reservation.agent = this.customer._id;
          } else {
            this.reservation.customer = this.customer._id;
            this.reservation.agent = null;
          }
          await this.checkIfCreditPaymentApplies(this.customer, this.payment);
        }
      }
    },
    getPriceByPrecision(amount, currencyPrecision) {
      let total = amount / Math.pow(10, currencyPrecision);
      return total.toFixed(2);
    },
    async checkIfCreditPaymentApplies(customer, payment = null) {
      if (
        payment ||
        ["EXPIRED", "CANCELLED"].includes(this.reservation.status)
      ) {
        this.creditAvailable = true;
      } else {
        if (["travel_agency", "travel_access"].indexOf(customer.type) > -1) {
          let grossPrice = this.getPriceByPrecision(
            this.pricing.retail,
            this.pricing.currencyPrecision
          );
          let priceService = await this.calculateGroosPrice(
            grossPrice,
            this.pricing.currency,
            customer.currency.code
          );
          let isAvailable = customer.credit.available >= priceService;
          if (!(customer.credit.status && isAvailable)) {
            if (!customer.credit.status) {
              this.reservation.payment_type =
                this.reservation.payment_type === "credit"
                  ? "card"
                  : this.reservation.payment_type;
              this.creditAvailable = true;
              this.$notify({
                type: "warning",
                title: "Important!",
                message: `The Partner ${customer.company_name} does not have available credit, you can add more credit on Customers`,
                icon: "flaticon-warning-1"
              });
            } else {
              this.$notify({
                type: "warning",
                title: "Important!",
                message: `The Partner ${customer.company_name} does not have available credit, you can add more credit on Customers`,
                icon: "flaticon-warning-1"
              });
              this.creditAvailable = this.reservation.payment_type !== "credit";
            }
          } else {
            this.creditAvailable = true;
            this.reservation.payment_type = "credit";
          }
        } else {
          if (this.reservation.payment_type === "credit") {
            this.$notify({
              type: "warning",
              title: "Important!",
              message: `This customer ${customer.first_name} ${customer.last_name} does not have available credit. The  Payment Type was upgraded to Credit Card, you can add more credit on Customers`,
              icon: "flaticon-warning-1"
            });
            this.reservation.payment_type = "card";
          }
          this.creditAvailable = true;
        }
      }
    },
    async calculateGroosPrice(grossPrice, fromCurrencyCode, toCurrencyCode) {
      if (fromCurrencyCode === toCurrencyCode) {
        return grossPrice;
      } else {
        return await this.conversionCurrency(
          grossPrice,
          fromCurrencyCode,
          toCurrencyCode
        );
      }
    },
    async conversionCurrency(grossPrice, fromCurrencyCode, toCurrencyCode) {
      try {
        let { data } = await CurrenciesAPI.conversionCurrency(
          fromCurrencyCode,
          toCurrencyCode
        );
        if (data) {
          if (data.conversion_rate) {
            let rate = parseFloat(data.conversion_rate.toFixed(5));
            return rate * grossPrice;
          } else {
            return 0;
          }
        } else {
          return 0;
        }
      } catch (error) {
        return 0;
      }
    },
    getStatusClass(currentStatus) {
      if (currentStatus === "ON_HOLD") {
        return "status-draft";
      } else if (currentStatus === "CANCELLED") {
        return "status-cancelled";
      } else if (currentStatus === "EXPIRED") {
        return "status-expired";
      } else if (currentStatus === "CONFIRMED") {
        return "status-confirmed";
      } else {
        return {};
      }
    },
    getReservationStatusFormat(currentStatus) {
      if (currentStatus === "ON_HOLD") {
        return "Pending Payment";
      } else if (currentStatus === "CANCELLED") {
        return "Cancelled";
      } else if (currentStatus === "EXPIRED") {
        return "Expired";
      } else if (currentStatus === "CONFIRMED") {
        return "Confirmed";
      } else {
        return {};
      }
    },
    changePaymentType(value) {
      if (value !== "credit") {
        this.creditAvailable = true;
      } else {
        if (this.customer) {
          this.checkIfCreditPaymentApplies(this.customer, this.payment);
        }
      }
    },
    getTitleByGender(gender) {
      if (gender === "male") {
        return "Mr.";
      } else if (gender === "female") {
        return "Mrs.";
      } else {
        return "Mx.";
      }
    },
    openRequestRecipientsModal() {
      this.showRequestRecipients = true;
    },
    closeRequestRecipientsModal(status) {
      this.showRequestRecipients = status;
    },
    async populateRecipients(payload) {
      let { recipients, reason } = payload;
      this.closeRequestRecipientsModal(false);
      this.setLoad(true);
      let booking = await this.updatedBookingById(
        this.uuid,
        this.populateBooking(lodash.cloneDeep(this.booking)),
        this.providerId
      );
      await this.updateReservation(
        this.reservationId,
        { ...this.reservation, ...this.populateReservation(booking) },
        recipients,
        reason,
        this.route
      );
      this.setLoad(false);
    },
    onCopy() {
      this.$notify({
        type: "success",
        title: "Success!",
        message: "The text has been copied to the clipboard",
        icon: "flaticon-check-3"
      });
    },
    onErrorCopy() {
      this.$notify({
        type: "danger",
        title: "Error!",
        message: "The text couldn't be copied",
        icon: "flaticon-remove"
      });
    },
    getDate(date) {
      return moment(date)
        .utc(true)
        .format("DD-MMM-YYYY");
    },
    getTime(time) {
      return moment(time, ["hh:mm A"])
        .utc(false)
        .format("hh:mm A");
    },
    remoteMethod(value) {
      if (value !== "") {
        this.loading = true;
        this.countryOptions = this.countries.filter(country => {
          return country.name.toLowerCase().indexOf(value.toLowerCase()) > -1;
        });
        this.loading = false;
      } else {
        this.countryOptions = [];
      }
    },
    phoneInput(value, payload) {
      let result = payload;
      if (result.isValid) {
        this.booking.contact.phone = result.number.e164;
        let passenger = this.populatePassenger(
          lodash.cloneDeep(this.booking.contact)
        );
        this.reservation.passengers = [passenger];
      }
    },
    getCurrenSymbolByCurrency(currency) {
      if (currency === "USD") {
        return "$";
      } else if (currency === "EUR") {
        return "€";
      } else if (currency === "GBP") {
        return "£";
      }
    },
    getFormatPrice(pricing) {
      let total = pricing.retail / Math.pow(10, pricing.currencyPrecision);
      return total.toFixed(2);
    },
    getDurationByOption(option) {
      return option ? option.duration : "";
    },
    populateCustomer(customer, agent) {
      if (agent) {
        let agentId = agent._id;
        this.customerId = agentId;
        this.reservation.agent = agentId;
      } else {
        let customerId = customer._id;
        this.customerId = customerId;
        this.reservation.agent = null;
      }
      this.reservation.customer = customer._id;
      this.customer = customer;
    },
    getLocalDateStart(currentMonth) {
      return moment()
        .month(currentMonth)
        .startOf("month")
        .subtract(15, "days")
        .format("YYYY-MM-DD");
    },
    getLocalDateEnd(currentMonth) {
      return moment()
        .month(currentMonth)
        .endOf("month")
        .add(15, "days")
        .format("YYYY-MM-DD");
    },
    async getAvailabilityAndSchedules() {
      this.availableTimeRequest = "PENDING";
      this.availabilities = await this.availabilityCheck(
        this.productId,
        this.booking.optionId,
        this.localDateStart,
        this.localDateEnd,
        this.booking.units,
        this.providerId
      );
      this.availableTimeRequest = "RESPONSE";
      this.schedules = this.getSchedules(
        this.localDateStart,
        this.localDateEnd,
        this.availabilities
      );
    },
    async subtractPAX(unit, quantity) {
      let indexUnit = this.units.findIndex(item => item.id === unit.id);
      if (indexUnit > -1) {
        this.units[indexUnit].quantity =
          quantity + -1 >= 0 ? this.units[indexUnit].quantity - 1 : 0;
        this.booking.units = this.units.filter(unit => unit.quantity > 0);
        await this.getAvailabilityAndSchedules();
      }
      this.selectTravelDate(this.booking.travelDate);
    },
    async addPAX(unit, quantity) {
      let indexUnit = this.units.findIndex(item => item.id === unit.id);
      if (indexUnit > -1) {
        this.units[indexUnit].quantity = this.units[indexUnit].quantity + 1;
        this.booking.units = this.units.filter(unit => unit.quantity > 0);
        await this.getAvailabilityAndSchedules();
      }
      this.selectTravelDate(this.booking.travelDate);
    },
    selectTravelDate(travelDate) {
      let schedule = this.schedules.find(schedule => {
        return schedule.date === travelDate;
      });
      if (schedule) {
        this.optionUnits = this.getOptionsUnitsWithPrices(
          schedule.availabilities,
          this.product.defaultCurrency,
          this.option.units
        );
        this.availability = this.getAvailabilityOptions(
          schedule.availabilities
        );
        if (this.availabilityType === "OPENING_HOURS") {
          let [availability] = schedule.availabilities;
          if (availability) {
            this.booking.availabilityId = availability.id;
            this.pickupAvailable = availability.pickupAvailable;
            this.pickupRequired = availability.pickupRequired;
            this.pickupPoints = availability.pickupPoints;
            this.pricing = availability.pricing;
            this.populateCommission(
              this.customer,
              this.pricing,
              this.commissionApplied
            );
          } else {
            this.booking.availabilityId = null;
          }
        } else {
          this.booking.availabilityId = null;
        }
      }
    },
    selectTravelDateInCalendar(dates, travelDate) {
      this.selectTravelDate(travelDate);
    },
    async selectMonth(dates, travelDate, instance) {
      this.currentMonth = instance.currentMonth;
      this.localDateStart = this.getLocalDateStart(this.currentMonth);
      this.localDateEnd = this.getLocalDateEnd(this.currentMonth);
      await this.getAvailabilityAndSchedules();
    },
    async availabilityCheck(
      productId,
      optionId,
      localDateStart,
      localDateEnd,
      units,
      providerId
    ) {
      try {
        let { data } = await VentrataAPI.availabilityCheck(
          {
            productId: productId,
            optionId: optionId,
            localDateStart: localDateStart,
            localDateEnd: localDateEnd,
            units: units
          },
          providerId
        );
        return data.length ? data : [];
      } catch (error) {
        return [];
      }
    },
    getPriceByUnit(pricingFrom = [], defaultCurrency) {
      let total = 0;
      let pricing = pricingFrom.find(
        element => element.currency === defaultCurrency
      );
      if (pricing) {
        total = pricing.retail / Math.pow(10, pricing.currencyPrecision);
      }
      return total.toFixed(2);
    },
    getSchedules(localDateStart, localDateEnd, availabilities = []) {
      let dates = Array.from(
        moment.range(localDateStart, localDateEnd).by("day")
      );
      return dates.map(date => {
        return {
          date: date.format("YYYY-MM-DD"),
          availabilities: this.getAvailabilitiesByDate(
            date.format("YYYY-MM-DD"),
            availabilities
          )
        };
      });
    },
    getAvailabilitiesByDate(date, availabilities = []) {
      return availabilities.filter(availability => {
        return availability.id.includes(date);
      });
    },
    getAvailabilityOptions(availabilities = []) {
      if (this.availabilityType === "OPENING_HOURS") {
        return {
          status: availabilities.length,
          type: this.availabilityType,
          options: [
            {
              intervalName: null,
              intervalType: "ALL_DAY",
              dates: availabilities
            }
          ]
        };
      } else {
        let morningHours = this.getAvailabilitiesByInterval(
          "6:00 AM",
          "11:59 AM",
          availabilities
        );
        let afternoonHours = this.getAvailabilitiesByInterval(
          "12:00 PM",
          "11:59 PM",
          availabilities
        );
        return {
          status: morningHours.length > 0 || afternoonHours.length > 0,
          type: this.availabilityType,
          options: [
            {
              intervalName: "Morning",
              intervalType: "MORNING",
              dates: morningHours
            },
            {
              intervalName: "Afternoon",
              intervalType: "AFTERNOON",
              dates: afternoonHours
            }
          ]
        };
      }
    },
    getAvailabilitiesByInterval(
      startInterval,
      endInterval,
      availabilities = []
    ) {
      return availabilities.filter(availability => {
        const time = moment.parseZone(availability.id);
        const timeToCheck = moment(time.format("h:mm A"), "h:mm A");
        return timeToCheck.isBetween(
          moment(startInterval, "h:mm A"),
          moment(endInterval, "h:mm A"),
          null,
          "[)"
        );
      });
    },
    getOptionTime(availabilityId) {
      return moment.parseZone(availabilityId).format("h:mm A");
    },
    selectAvailabilityId(availability) {
      if (availability.status !== "SOLD_OUT") {
        this.booking.availabilityId = availability.id;
        this.pickupAvailable = availability.pickupAvailable;
        this.pickupRequired = availability.pickupRequired;
        this.pickupPoints = availability.pickupPoints;
        this.pricing = availability.pricing;
        this.populateCommission(
          this.customer,
          this.pricing,
          this.commissionApplied
        );
      }
    },
    getFormatPrice(pricing) {
      let total = pricing.retail / Math.pow(10, pricing.currencyPrecision);
      return total.toFixed(2);
    },
    getCapacity(availability) {
      if (availability.status === "AVAILABLE" && availability.capacity > 0) {
        return `${availability.capacity} Remaining`;
      } else if (availability.status === "FREESALE") {
        return "Available";
      } else if (availability.status === "SOLD_OUT") {
        return "Sold Out";
      } else if (availability.status === "LIMITED") {
        return `${availability.capacity} Limited`;
      } else {
        return "";
      }
    },

    getCustomerName(customer) {
      if (
        ["travel_agency", "travel_access", "business"].includes(customer.type)
      ) {
        return `${customer.company_name} - ${customer.first_name} ${customer.last_name}`;
      } else {
        return `${customer.first_name} ${customer.last_name}`;
      }
    },
    isCompany(type) {
      return ["travel_agency", "travel_access"].includes(type);
    },
    getInterval(quantity) {
      const interval = [];
      for (let i = 0; i < quantity; i++) {
        interval.push(i + 1);
      }
      return interval;
    },
    getUnitItems(units = []) {
      return units
        .map(unit => {
          let interval = this.getInterval(unit.quantity);
          return interval.map(item => {
            return {
              unitId: unit.id,
              uuid: uuidv4()
            };
          });
        })
        .flat();
    },
    populatePassenger(contact) {
      return {
        _id: null,
        reference: uuidv4(),
        firstName: contact.firstName,
        lastName: contact.lastName,
        fullName: contact.fullName,
        email: contact.email,
        phone: contact.phone,
        gender: contact.gender,
        type: contact.type,
        primary: contact.primary,
        flightNumber: contact.flightNumber
      };
    },
    populateContact(cantact) {
      return {
        fullName: cantact.fullName,
        firstName: cantact.firstName,
        lastName: `${cantact.fullName} ${cantact.firstName}`,
        emailAddress: cantact.email,
        phoneNumber: cantact.phone,
        country: cantact.country,
        notes: cantact.notes
      };
    },
    populateBooking(booking) {
      return {
        uuid: uuidv4(),
        expirationMinutes: 720,
        productId: booking.productId,
        optionId: booking.optionId,
        availabilityId: booking.availabilityId,
        pickupRequested: booking.pickupPointId ? true : false,
        pickupPointId: booking.pickupPointId,
        pickupNotes: booking.pickupNotes,
        unitItems: this.getUnitItems(booking.units),
        contact: this.populateContact(booking.contact)
      };
    },
    populateReservation(booking) {
      return booking
        ? {
            uuid: booking.uuid,
            id: booking.id,
            notes: booking.notes,
            option: booking.option,
            optionId: booking.optionId,
            pricing: booking.pricing,
            product: booking.product,
            productId: booking.productId,
            status: booking.status,
            unitItems: booking.unitItems,
            settlementMethod: booking.settlementMethod,
            supplierReference: booking.supplierReference,
            utcConfirmedAt: booking.utcConfirmedAt,
            utcCreatedAt: booking.utcCreatedAt,
            utcExpiresAt: booking.utcExpiresAt,
            utcNoshowedAt: booking.utcNoshowedAt,
            utcRebookedAt: booking.utcRebookedAt,
            utcRedeemedAt: booking.utcRedeemedAt,
            utcUpdatedAt: booking.utcUpdatedAt,
            contact: booking.contact,
            voucher: booking.voucher,
            availability: booking.availability,
            availabilityId: booking.availabilityId,
            deliveryMethods: booking.deliveryMethods,
            resellerReference: booking.resellerReference,
            meetingPoint: booking.meetingPoint,
            meetingPointCoordinates: booking.meetingPointCoordinates,
            meetingLocalDateTime: booking.meetingLocalDateTime,
            pickupPointId: booking.pickupPointId,
            pickupRequested: booking.pickupRequested,
            pickupPoint: booking.pickupPoint,
            pickupNotes: booking.pickupNotes,
            duration: booking.duration,
            cancellable: booking.cancellable,
            cancellation: booking.cancellation,
            confirmable: booking.confirmable
          }
        : {};
    },
    async selectOption(option) {
      this.option = option;
      this.booking.optionId = option.id;
      this.optionUnits = this.getOptionsUnitsWithPricesBycurrency(
        this.product.defaultCurrency,
        this.option.units
      );
      this.itinerary = this.option.itinerary ? this.option.itinerary : [];
      this.units = this.option.units.map(unit => {
        return {
          id: unit.id,
          quantity: 0
        };
      });
      this.booking.units = this.units.filter(unit => unit.quantity > 0);
      await this.getAvailabilityAndSchedules();
      this.selectTravelDate(this.booking.travelDate);
    },
    getLabelPax(unitItems = []) {
      let units = unitItems.map(e => e.unit.title);
      return [...new Set(units)]
        .map(item => {
          return `${units.filter(unit => unit === item).length} ${item}`;
        })
        .join(" / ");
    },
    getResponsibleName(responsible) {
      try {
        if (responsible.type === "Customers") {
          return `${responsible.ref.first_name} ${responsible.ref.last_name}`;
        } else if (responsible.type === "Operators") {
          return `${responsible.ref.contactPerson.firstName} ${responsible.ref.contactPerson.lastName}`;
        } else if (responsible.type === "Users") {
          return `${responsible.ref.personal_info.first_name} ${responsible.ref.personal_info.last_name}`;
        }
        return "Unknown";
      } catch (error) {
        return "Unknown";
      }
    },
    getResponsiblePosition(responsible) {
      try {
        if (responsible.type === "Customers") {
          return formatClientType(responsible.ref.type);
        } else if (responsible.type === "Operators") {
          return "Supplier";
        } else if (responsible.type === "Users") {
          return formatPosition(responsible.ref.agreement.position);
        }
        return "Unknown";
      } catch (error) {
        return "Unknown";
      }
    },
    getTitleByGender(gender) {
      if (gender === "male") {
        return "Mr.";
      } else if (gender === "female") {
        return "Mrs.";
      } else {
        return "Mx.";
      }
    },
    beforeRouteLeave(to, from, next) {
      if (!this.sigout) {
        let isEqual = this.areThereChanges();
        if (isEqual && !this.isReservationUpdated) {
          Swal.fire({
            title: "Important",
            html:
              "The Reservation has been modified.<br> Do you want to save changes?",
            imageUrl: require("rhomtrip_assets/src/img/icons/alerts/warning.png"),
            buttonsStyling: false,
            showCloseButton: true,
            showCancelButton: true,
            focusConfirm: false,
            reverseButtons: true,
            cancelButtonText: "No",
            confirmButtonText: "Yes",
            confirmButtonClass: "btn btn-primary btn-small-one"
          }).then(result => {
            if (result.value) {
              this.saveReservation(to.path);
            } else if (result.dismiss === Swal.DismissReason.cancel) {
              next();
            }
          });
        } else {
          next();
        }
      } else {
        next();
      }
    },
    getTravelDate(availabilityId) {
      if (availabilityId) {
        return moment.parseZone(availabilityId).format("DD-MMM-YYYY");
      }
      return "";
    },
    getStartTime(availabilityId) {
      if (availabilityId) {
        return moment.parseZone(availabilityId).format("hh:mm A");
      }
      return "";
    },
    getProductImages(product) {
      if (product.coverImageUrl) {
        return product.coverImageUrl;
      } else if (product.galleryImages.length) {
        let [image] = product.galleryImages.map(gallery => gallery.url);
        return image;
      } else if (product.bannerImageUrl) {
        return product.bannerImageUrl;
      } else if (product.bannerImages.length) {
        let [image] = product.bannerImages.map(banner => banner.url);
        return image;
      } else {
        return this.noImage;
      }
    },
    getReservationUpdateErrorMessage(status) {
      if (status === "CANCELLED") {
        return `The reservation cannot be updated because its status is cancelled.`;
      } else if (status === "EXPIRED") {
        return `The reservation cannot be updated because its status is expired.`;
      } else {
        return `The reservation cannot be updated.`;
      }
    },
    getPriceByCurrencyPrecision(price, currencyPrecision) {
      let total = price / Math.pow(10, currencyPrecision);
      return total.toFixed(2);
    },
    getOptionsUnitsWithPrices(availabilities, currency, units = []) {
      let [availability] = availabilities;
      return units.map(unit => {
        unit.pricing = availability
          ? availability.unitPricing.find(pricing => pricing.unitId === unit.id)
          : unit.pricingFrom.find(pricing => pricing.currency === currency);
        return unit;
      });
    },
    getOptionsUnitsWithPricesBycurrency(currency, units = []) {
      return units.map(unit => {
        unit.pricing = unit.pricingFrom.find(
          pricing => pricing.currency === currency
        );
        return unit;
      });
    },
    getFlatPickerSettings(travelDate) {
      let toDay = moment().utc(true);
      let date = moment(travelDate).utc(false);
      return {
        inline: true,
        altFormat: "d-M-Y",
        altInput: true,
        minDate: date.isSameOrAfter(toDay) ? "today" : travelDate,
        maxDate: toDay.add(1, "year").format(),
        dateFormat: "Y-m-d",
        allowInput: false
      };
    },
    async getCommissionsByProductId(productId) {
      try {
        let { data } = await ReservationsAPI.getCommissionByReference(
          productId,
          this.sesion.token
        );
        return data.status ? data.data.amount : 5;
      } catch (error) {
        return 5;
      }
    },
    getSourceOrigin(source) {
      if (source) {
        return source.origin;
      }
      return "";
    },
    getServiceProvider(source) {
      if (source) {
        if (source.provider === "VENTRATA") {
          return "Ventrata";
        } else {
          return "RhomTrip";
        }
      }
      return "";
    },
    allIntervalsEmpty(intervals) {
      return intervals.every(interval => interval.dates.length === 0);
    },
    hasMoreThanFiveDates(intervals) {
      const totalDates = intervals.reduce((acc, interval) => {
        return acc + interval.dates.length;
      }, 0);
      return totalDates > 6;
    },

    populateCommission(customer, pricing, commissionApplied) {
      //Calculate Commissions Platform
      this.reservation.commissions.platform.percentage = this.getCommissionByCustomer(
        customer,
        commissionApplied
      );

      this.reservation.commissions.platform.amount = calculateCommissionAmount(
        this.getGrossPriceByPricing(pricing),
        this.reservation.commissions.platform.percentage
      );
    },
    getCommissionByCustomer(customer, commissionApplied) {
      if (customer) {
        let commercialTerms = customer.commercialTerms || customer.type_charge;
        return ["travel_access", "travel_agency"].includes(customer.type) &&
          commercialTerms === "commission"
          ? commissionApplied
          : 0;
      }
      return 0;
    },
    getGrossPriceByPricing(pricing) {
      let total = pricing.retail / Math.pow(10, pricing.currencyPrecision);
      return parseFloat(total.toFixed(2));
    },
    goToPreviousPage() {
      goBack(this);
    },

    /**
     *
     * Booking Action Methods
     */
    async handlerSendPaymentLink(bookings, client, callback) {
      const validationRules = [
        {
          check: hasPaidBookings,
          message:
            "You are trying to request payment for one or more reservations which have been paid"
        },
        {
          check: hasCanceledBookings,
          message:
            "You are trying to request payment for one or more reservations which have been cancelled"
        },
        {
          check: hasBookingsWithPaymentLink,
          message:
            "One or more of the selected reservations contains a valid payment link, wait until the payment link has expired"
        },
        {
          check: hasExpiredBookings,
          message:
            "You are trying to request payment for one or more reservations with an expired rate. Please recalculate the rates for these pending reservations before sending the payment link."
        },
        {
          check: hasDraftBookings,
          message:
            "You are trying to request payment for one or more reservations that have not been completed"
        },
        {
          check: isSameUserForAllBookings,
          message: "Selected reservations must have the same customer name"
        },
        {
          check: bookings => bookings.length > 15,
          message:
            "You can only send payment links for a maximum of 15 reservations at a time."
        }
      ];

      for (const rule of validationRules) {
        if (rule.check(bookings)) {
          this.$notify({
            type: "warning",
            title: "Payment link could not be sent!",
            message: rule.message,
            icon: "flaticon-warning-1"
          });
          return;
        }
      }

      let userId = client ? client._id : null;
      let userRole = client ? client.type : null;
      if (!userId && !userRole) {
        this.$notify({
          type: "warning",
          title: "User Identification Error",
          message:
            "An error occurred while identifying the user. Please try again.",
          icon: "flaticon-warning-1"
        });
        return;
      }

      let payload = {
        userId: userId,
        userRole: userRole,
        reservations: bookings.map(booking => booking._id)
      };
      await sendPaymentLink(payload, callback);
    },
    async sendPaymentLinkToCustomer(payload) {
      try {
        this.setLoad(true);
        let { data } = await ReservationsAPI.sendPaymentLink(
          payload,
          this.sesion.token
        );
        this.setLoad(false);
        let result = data.data;
        if (result.send) {
          this.$notify({
            type: "success",
            title: "Payment Link Sent!",
            message:
              "Your payment email link has been sent to customer successfully",
            icon: "flaticon-remove"
          });
        } else {
          this.$notify({
            type: "danger",
            title: "Payment link was not sent!",
            message: "Please contact support via email",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "Please contact support via email",
          "Payment link was not sent!"
        );
      }
    },
    async resendEmailNotificationByBookingId(bookingId, recipients = []) {
      try {
        this.setLoad(true);
        let { data } = await ReservationsAPI.resendEmailToUsersByReservationId(
          bookingId,
          recipients,
          this.sesion.token
        );
        this.setLoad(false);
        if (data.status) {
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The notifications have been forwarded successfully",
            icon: "flaticon-check-3"
          });
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The notifications couldn't be sent",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "The operation couldn't be completed. Please try again"
        );
      }
    },
    async otaConfirmBookingById(bookingId) {
      try {
        this.setLoad(true);
        let { data } = await ReservationsAPI.otaConfirmReservationById(
          bookingId,
          {},
          this.sesion.token
        );
        this.setLoad(false);
        let response = data.data;
        if (response.confirmed) {
          await this.initReservation(bookingId);
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The Reservation has been Confirmed",
            icon: "flaticon-check-3"
          });
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Reservation cannot be Confirmed",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(error, "The Reservation cannot be Confirmed");
      }
    },
    async otaCancelBookingById(bookingId, reason = "") {
      try {
        this.setLoad(true);
        let { data } = await ReservationsAPI.otaCancelReservationById(
          bookingId,
          { reason: reason },
          this.sesion.token
        );
        this.setLoad(false);
        let response = data.data;
        if (response.canceled) {
          await this.initReservation(bookingId);
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The Reservation has been Cancelled",
            icon: "flaticon-check-3"
          });
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Reservation cannot be Cancelled",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(error, "The Reservation cannot be Cancelled");
      }
    },
    async handlerMarkReservationsAsPaid(bookings, callback) {
      const validationRules = [
        {
          check: hasPaidBookings,
          message:
            "You are trying to pay one or more reservations which have been paid"
        },
        {
          check: hasCanceledBookings,
          message:
            "You are trying to pay one or more reservations which have been cancelled"
        },
        {
          check: hasBookingsWithPaymentLink,
          message:
            "One or more of the selected reservations contains a valid payment link, wait until the payment link has expired"
        },
        {
          check: hasExpiredBookings,
          message:
            "You are trying to pay one or more reservations with an expired rate."
        }
      ];

      for (const rule of validationRules) {
        if (rule.check(bookings)) {
          this.$notify({
            type: "warning",
            title: "The Reservations cannot be Paid!",
            message: rule.message,
            icon: "flaticon-warning-1"
          });
          return;
        }
      }
      await markReservationsAsPaid(bookings, callback);
    },
    async markReservationsAsPaidById(reservations = []) {
      try {
        this.setLoad(true);
        let { data } = await ReservationsAPI.markReservationsAsPaid(
          reservations,
          this.sesion.token
        );
        this.setLoad(false);
        if (data.status) {
          let { payments } = data.data;
          if (payments.reduce((a, b) => a && b, true)) {
            await this.initReservation(this.reservationId);
            this.$notify({
              type: "success",
              title: "Success!",
              message: "The Reservations has been Paid",
              icon: "flaticon-check-3"
            });
          } else {
            this.$notify({
              type: "danger",
              title: "Error!",
              message: "One or more reservations could not be paid",
              icon: "flaticon-remove"
            });
          }
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Reservations cannot be Paid",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(error, "The Reservation cannot be Paid");
      }
    },
    async downloadPDFType(bookingId, reference, isTransfer, pdfType, client) {
      try {
        let voucherType = isTransfer ? "product" : "transfer";
        this.setLoad(true);
        let { data } = await ReservationsAPI.downloadPDF(
          pdfType,
          bookingId,
          client,
          voucherType
        );
        this.setLoad(false);
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Voucher(${reference}).pdf`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        this.setLoad(false);
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The data was not download. Please try again",
          icon: "flaticon-remove"
        });
      }
    },
    async downloadTickets(bookingId, client, reference) {
      try {
        this.setLoad(true);
        let { data } = await ReservationsAPI.downloadPDFTickets(
          bookingId,
          client,
          "ALL",
          null
        );
        this.setLoad(false);
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Tickets(${reference}).pdf`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        this.setLoad(false);
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The data was not download. Please try again",
          icon: "flaticon-remove"
        });
      }
    },
    ...mapActions(["getSesion"]),
    ...mapMutations([
      "setSigOut",
      "setLoad",
      "setCustomerOptions",
      "setItemsBread"
    ])
  },
  components: {
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [DatePicker.name]: DatePicker,
    [TimeSelect.name]: TimeSelect,
    [MessageBox.name]: MessageBox,
    [Message.name]: Message,
    flatPicker,
    VueTelInput,
    WSelect,
    AddCustomer,
    ProductCard: ProductCard,
    RequestRecipients,
    ReservationHistory,
    Charges: Charges,
    PaymentStatus: PaymentStatus,
    FirstBookingBadge: FirstBookingBadge,
    FadeTransition,
    Countdown: Countdown
  },
  validations: {
    booking: {
      units: {
        required,
        minLength: minLength(1)
      },
      travelDate: {
        required: false
      },
      availabilityId: {
        required
      },
      pickupPointId: {
        required: false
      },
      pickupNotes: {
        required: false
      },
      contact: {
        country: {
          required: false
        },
        email: {
          required,
          email,
          minLength: minLength(3)
        },
        firstName: {
          required,
          minLength: minLength(2),
          maxLength: maxLength(45),
          ValName
        },
        fullName: {
          required,
          minLength: minLength(2),
          maxLength: maxLength(90),
          ValName
        },
        lastName: {
          required,
          minLength: minLength(2),
          maxLength: maxLength(45),
          ValName
        },
        phone: {
          required,
          minLength: minLength(10),
          maxLength: maxLength(17)
        }
      }
    },
    reservation: {
      customer: {
        required,
        alphaNum
      },
      booking_reference: {
        maxLength: maxLength(25)
      },
      deal_number: {
        maxLength: maxLength(10),
        customValidator: function(value) {
          if (value) {
            var regex = /^[A-Za-z]{3}-\d{5,6}$/;
            if (regex.test(value)) {
              return true;
            } else {
              return false;
            }
          } else {
            return true;
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      "locations",
      "customerOptions",
      "sesion",
      "userRole",
      "load",
      "sigout",
      "itemsBread",
      "countries"
    ]),
    canUserUpdate() {
      return isUserAuthorized("RESERVATIONS", this.userRole, "UPDATE");
    },
    canUserMarkBookingAsPaid() {
      return isUserAuthorized("RESERVATIONS", this.userRole, "MARK_AS_PAID");
    },
    canUserSendPaymentLink() {
      return isUserAuthorized(
        "RESERVATIONS",
        this.userRole,
        "SEND_PAYMENT_LINK"
      );
    },
    canUserChangeStatus() {
      return isUserAuthorized("RESERVATIONS", this.userRole, "CHANGE_STATUS");
    }
  }
};
</script>
